import searchResultsTabMixin from '@phoenix/mixins/searchResultsTabMixin';
import { TAB_STORES } from '@maison/helpers/search-helper';
import Store from '@phoenix/components/Store';

export default {
  mixins: [searchResultsTabMixin],

  data() {
    return {
      tab: TAB_STORES,
    };
  },

  computed: {
    boutiques() {
      return this.items ? this.items.filter((item) => item.type === 'boutique') : [];
    },

    retailers() {
      return this.items ? this.items.filter((item) => item.type === 'reseller') : [];
    },

    hasBoutiques() {
      return this.boutiques.length > 0;
    },

    hasRetailers() {
      return this.retailers.length > 0;
    },
  },

  methods: {
    getStatus(store) {
      return new Store(store.openingHours, store.specialDays, store.timezone, store.isOnline).getStatusLabel();
    },
  },
};
